<emperor-card-header
  class="card-header"
  [color]="EmperorCardHeaderColor.PRIMARY"
>
  {{ config.data?.naicsDescription }}
  <emperor-icon
    class="close-icon"
    name="close_1"
    emperorDialogClose
  ></emperor-icon>
</emperor-card-header>
<div class="body" [innerHTML]="sanitizedExplanation()"></div>
